(function () {
    document.querySelectorAll('.section-news-list').forEach(section => {
        const moreContainer = section.querySelector('.more-container');
        const moreContent = section.querySelector('.more-content');
        const moreToggle = section.querySelector('.more-toggle');

        if (!moreContainer || !moreContent || !moreToggle) {
            return;
        }

        moreToggle.addEventListener('click', () => {
            section.classList.add('expanded');
            moreContainer.style.height = moreContent.getBoundingClientRect().height + 'px';
        });
    });
}());